import { render, staticRenderFns } from "./pause-minimal.vue?vue&type=template&id=0e2e6254&scoped=true&"
import script from "./pause-minimal.vue?vue&type=script&lang=js&"
export * from "./pause-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2e6254",
  null
  
)

export default component.exports